export default __webpack_public_path__ + "static/media/CYP.374f0f98.svg";